import { createErrorWrapper } from '../utils';

export const LOADING_ERROR = 'COMMON.LOADING_ERROR';

export const loadingErr = createErrorWrapper(LOADING_ERROR, 'Failed to load data');
